import { render, staticRenderFns } from "./afterSaleProject.vue?vue&type=template&id=92df40ba&scoped=true&"
import script from "./afterSaleProject.vue?vue&type=script&lang=js&"
export * from "./afterSaleProject.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleProject.vue?vue&type=style&index=0&id=92df40ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92df40ba",
  null
  
)

export default component.exports